<script>
import {mapActions} from 'vuex';
import {GET_API_KEY} from '@/store/actionTypes';
import ButtonComponent from '@/components/base-components/buttons/ButtonComponent.vue';
import {switchToMainURL} from '@/api/apiUrlController';
import ImageComponent from '@/components/base-components/ImageComponent.vue';
import {CUSTOM_EVENTS} from '@/const';

export default {
  name: 'ErrorReloadScreen',
  components: {ImageComponent, ButtonComponent},
  ONE_MINUTE: 60000,
  ONE_SECOND: 1000,
  data() {
    return {
      seconds: 0,
      error: false,
      timeoutId: null,
      processing: false,
      urls: [],
    };
  },
  watch: {
    async error() {
      clearTimeout(this.timeoutId);
      this.seconds = this.error ? this.$options.ONE_MINUTE : 0;
      while (this.seconds) {
        const promise = new Promise((resolve) => {
          this.timeoutId = setTimeout(resolve, this.$options.ONE_SECOND);
        });
        await promise.then(() => {
          this.seconds -= this.$options.ONE_SECOND;
        });
      }
    },
    urls() {
      this.error = this.urls.length;
    },
  },
  methods: {
    ...mapActions({
      getApiKey: GET_API_KEY,
    }),
    onError({detail}) {
      if (detail?.error) {
        !this.urls.includes(detail.url) && this.urls.push(detail.url);
      } else if (this.urls.includes(detail.url)) {
        this.urls = this.urls.filter((url) => detail.url !== url);
      }
    },
    requestKey() {
      switchToMainURL();
      this.processing = true;
      this.getApiKey().then(() => {
        location.reload();
      }).finally(() => {
        this.processing = false;
      });
    },
  },
  created() {
    window.document.removeEventListener(CUSTOM_EVENTS.API_KEY, this.onError);
    window.document.addEventListener(CUSTOM_EVENTS.API_KEY, this.onError);
  },
};
</script>

<template>
  <div>
    <div v-if="error" class="reload-wrapper">
      <div class="reload-wrapper__icon">
        <image-component path="/image/error.png" :local="true"/>
      </div>
      <h3>WHOOPS!</h3>
      <div>
          <p>Apologies! Our service is currently experiencing technical difficulties.</p>
          <p>Please refresh the page</p>
      </div>
      <button-component
          :disabled="Boolean(seconds || processing)"
          @btn-click="requestKey"
          variant="bordered"
          title="reload page"
      >
          Reload page {{ seconds ? `after ${seconds / 1000} seconds` : ''}}
      </button-component>
    </div>
    <slot v-else/>
  </div>
</template>

<style scoped lang="scss">
.reload-wrapper {
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  font-style: normal;

  p {
    margin: 0;
    padding: 0;
  }
}

.reload-wrapper__icon {
  max-width: 60vw;
  max-height: 40vh;

  svg, img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
